<template>
  <span>
    <span 
      :class="asGroup ? 'chip-wrap':''"
      @dragstart="dragStartHandler($event, wigo[0])"
      @drag="dragHandler($event)"
      :draggable="draggable"
    >
      <option-chip 
        v-for="option in wigo"
        :key="option.id"
        :option="option"
        :outlined="outlined"
        link
        :large="large"

        :close="close && (option.isCloseable === undefined || option.isCloseable)"
        :close-function="closeFunction"
        :close-function-parameters="[option]"
        :class="`${draggable ? 'rai-draggable__chip' : ''}`"
      />
    </span>
  </span>
</template>

<script>
import OptionChip from '@/components/global/OptionChip';

export default {
  name: "WigoChip",

  components: { OptionChip },

  props: {
    wigo: {
      type: Array,
      required: true,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    close: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    closeFunctionParameters: {
      type: Array,
      required: false,
      default: () => {},
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    asGroup: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  methods: {
    dragStartHandler (e, option) {
      if (!this.draggable) {
        // setting draggable to false is not sufficient..? wtf html5
        e.preventDefault()
      } else {
        e.dataTransfer.setData('id', option.id) // NB : not setting dataTransfer breaks draggable in firefox
        e.dataTransfer.setData('name', option.name)
      }
    },

    dragHandler (e) {
      if (e.screenY < 150) {
        window.scrollBy(0, -15)
      } else if ((window.outerHeight - e.screenY) < 80) {
        window.scrollBy(0, 15)
      }
    },
  }
};
</script>
<style scoped>
.chip-wrap {
  border: 1px dashed #062b89;
  padding: 12px 0px 16px 12px;
  border-radius: 5px;
  margin-right: 10px;
}
.rai-draggable__chip {
  cursor: grab;
}
</style>